





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { getHelpUrl } from "@/utils/getHelpUrl";
import Errors from "@/components/Errors.vue";
import { VueSlideoutEvent } from "../vue-slideout";
import { addClass, removeClass } from "@gemma/utils";
import { Nullable, RecordAny } from "@gemma/typescript-types";
import "./scss";
import { GemmaError } from "@gemma/errors";

@Component({
  components: {
    Errors,
  },
})
export default class VueFormSlideout extends Vue {
  @Prop({ type: String, default: undefined }) cancelText!: string;
  @Prop({ type: Boolean, default: true }) submitButton!: boolean;
  @Prop({ type: String, default: undefined }) submitText!: string;
  @Prop({
    type: String,
    default: function(this: Vue) {
      return this.$options.name;
    },
  })
  id!: string;
  @Prop({ type: Boolean, default: false }) submitDisabled!: boolean;

  @Prop({ type: String, default: null }) title!: boolean;
  @Prop({ type: Object, default: null }) submitIcon!: boolean;
  @Prop({ type: String, default: "" }) helpPath!: string;
  @Prop(Boolean) show!: boolean;
  @Prop({ type: [String, Array], required: false }) slideoutClasses!: string | string[];

  submitting: boolean = false;
  slideoutElementStyle?: RecordAny = undefined;
  disabled: boolean = this.submitDisabled;
  overlay_: Nullable<HTMLElement> = null;
  content_: Nullable<HTMLElement> = null;
  // close_: Nullable<Element>= null;
  helpUrl: Nullable<string> = null;
  vueSlideoutCreated: boolean = false;
  vueFormSlideoutCreated: boolean = false;
  createdEmitted: boolean = false;
  valid: boolean = true;

  get closeText() {
    return this.cancelText ? this.cancelText : this.submitButton && this.submitText ? "Cancel" : "Close";
  }

  get overlayStyle() {
    return this.submitting ? { display: "block", "z-index": (this.slideoutElementStyle ? parseInt(this.slideoutElementStyle.zIndex) : 300) + 9 } : { display: "none" };
  }

  @Watch("vueSlideoutCreated")
  onVueSlideoutCreated(newValue: boolean) {
    if (!this.createdEmitted && newValue && this.vueFormSlideoutCreated) {
      this.$emit("create", this);
      this.$emit("create" + this.id, this);
    }
  }

  @Watch("vueFormSlideoutCreated")
  onVueFormSlideoutCreated(newValue: boolean) {
    if (!this.createdEmitted && newValue && this.vueSlideoutCreated) {
      this.$emit("create", this);
      this.$emit("create" + this.id, this);
    }
  }

  @Watch("submitDisabled")
  onSubmitDisabled(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  created() {
    if (!this.id) {
      throw new GemmaError("Missing id on slideout", { sensitive: false, system: true, ui: false, data: { vm: this } });
    }
    this.$vueSlideout.$on(`${this.$Events.Succeeded}-${this.id}`, this.updateDisabledOverlay);
    this.$vueSlideout.$on(`${this.$Events.Failed}-${this.id}`, this.updateDisabledOverlay);
    //@ts-ignore
    this.$vueSlideout.$on(`${this.$Events.SubmitDisabled}-${this.id}`, this.disableSubmit);
    this.$vueSlideout.$on(`shown-${this.id}`, this.setStyle);
    this.helpUrl = getHelpUrl(this.currentRole, this.helpPath);
    this.vueFormSlideoutCreated = true;
  }

  destroyed() {
    this.$vueSlideout.$off(`${this.$Events.Succeeded}-${this.id}`, this.updateDisabledOverlay);
    this.$vueSlideout.$off(`${this.$Events.Failed}-${this.id}`, this.updateDisabledOverlay);
    //@ts-ignore
    this.$vueSlideout.$off(`${this.$Events.SubmitDisabled}-${this.id}`, this.disableSubmit);
    this.$vueSlideout.$off(`shown-${this.id}`, this.setStyle);
  }

  setStyle() {
    Vue.nextTick(() => {
      const el = this.$el as HTMLElement;
      if (el.style) {
        this.slideoutElementStyle = el.style;
        // this.slideoutZIndex = this.slideoutElementStyle.zIndex;
      }
    });
  }

  submit(event: Event) {
    this.submitting = true;
    if (!this.overlay_) {
      this.overlay_ = document.querySelector(`#${this.id}.vue-form-slideout > form main .submitting.overlay`);
      this.content_ = document.querySelector(`#${this.id}.vue-form-slideout > form main .content`);
    }

    addClass(`#${this.id}.vue-form-slideout > form > header .icon.group .close`, "disabled");
    const vueSlideoutEvent = new VueSlideoutEvent("submit-" + this.id, this.id, this, event);
    this.$vueSlideout.$emit(vueSlideoutEvent);
    this.$emit("submitted", vueSlideoutEvent);
  }

  cancel(event: Event) {
    if (this.submitting) {
      return;
    }
    const vueSlideoutCancelEvent = new VueSlideoutEvent("cancel-" + this.id, this.id, this, event);
    this.$vueSlideout.$emit(vueSlideoutCancelEvent);
    this.$emit("cancelled", vueSlideoutCancelEvent);

    const vueSlideoutHideEvent = new VueSlideoutEvent("hide-" + this.id, this.id, this, event);
    this.$vueSlideout.$emit(vueSlideoutHideEvent);
  }

  updateDisabledOverlay(): void {
    removeClass(`#${this.id}.vue-form-slideout > form > header .icon.group .close`, "disabled");
    this.submitting = false;
  }

  disableSubmit(disabled: boolean): void {
    this.disabled = disabled;
  }

  onHidden(event: Event): void {
    this.$emit("hidden", { id: this.id, event });
  }

  onEscape(event: Event): void {
    this.$emit("escape", { id: this.id, event });
  }

  onShow(event: Event): void {
    this.$emit("show", { id: this.id, event });
  }

  onCanSubmit(canSubmit: boolean): void {
    this.disableSubmit(!canSubmit);
  }
}
